/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import {
  addCartEntries,
  deductCartEntriesCount,
  getCartEntries,
} from "../../../services/commerceServices/cartServices";
import MessageStrip from "../../shared-ui/message-strip";
import ProductCard from "../../shared-ui/product-card";

// Interface for ProductComponent Props
interface ProductComponentProps {
  handleLearnMore?: (data: any) => void;
  handleSuccessMsg?: () => void;
  productsData?: any;
  subType?: string;
  colClassName?: string;
  handleAddtoCart: (productCode: number, quantity: number) => void;
  handleOutOfStock?: () => void;
  hitState?: boolean;
  needStateImages?: any;
  t?: any;
}

// Interface for ProductComponent State
interface ProductComponentState {
  quantity: number;
  successfullyAdded: boolean;
}

/**
 * ProductComponent component.
 *
 * @namespace ProductComponent
 */
class ProductComponent extends React.Component<
  ProductComponentProps,
  ProductComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      quantity: 1,
      successfullyAdded: false,
    };
  }

  render() {
    const settings = {
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dotsClass: "slick-dots slick-thumb",
    };

    return (
      <div
        className={
          this.props.subType === "best"
            ? "product-summary-wrapper bootstrap-wrapper"
            : "product-summary-wrapper other-products bootstrap-wrapper"
        }
      >
        <div className="inner-wrapper row col-md-12 clearfix">
          {this.props.productsData &&
            this.props.productsData.length > 0 &&
            // this.props.needStateImages &&
            // this.props.needStateImages.length > 0 &&
            this.props.productsData.map((item: any, index: number) => (
              <div
                className={`product-cards-wrapper pull-left ${this.props.colClassName}`}
              >
                <ProductCard
                  {...this.props}
                  subType={this.props.subType}
                  hitState={this.props.hitState}
                  productSliderSettings={settings}
                  productData={item}
                  needStateImages={this.props.needStateImages}
                  handleLearnMore={() =>
                    this.props.handleLearnMore &&
                    this.props.handleLearnMore(index)
                  }
                  handleAddCartClick={(productCode, quantity) =>
                    this.props.handleAddtoCart(productCode, quantity)
                  }
                  handleSuccessMsg={this.props.handleSuccessMsg}
                  handleOutOfStock={this.props.handleOutOfStock}
                />
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default ProductComponent;
